import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@material-ui/core';
import {
  useStripe,
  useElements,
  PaymentElement
} from '@stripe/react-stripe-js';

const PaymentForm = ({
  clientSecret,
  customerSessionClientSecret,
  returnUrl
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);

  useEffect(() => {
    const checkStatus = async () => {
      if (!stripe || !clientSecret) return;
      const { paymentIntent } = await stripe.retrievePaymentIntent(
        clientSecret
      );
      if (paymentIntent) {
        setPaymentStatus(paymentIntent.status);
      }
    };

    checkStatus();
  }, [stripe, clientSecret]);

  const handleSubmit = async event => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setProcessing(true);
    setError(null);

    const { error: submitError, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: returnUrl
      },
      redirect: 'always'
    });

    if (submitError) {
      setError(submitError.message);
    } else if (paymentIntent && paymentIntent.status === 'succeeded') {
      setPaymentStatus('succeeded');
    } else if (paymentIntent && paymentIntent.status === 'processing') {
      setPaymentStatus('processing');
    } else {
      setError(t('invoice:payment_not_confirmed'));
    }

    setProcessing(false);
  };

  if (paymentStatus === 'succeeded') {
    return (
      <Box mb={2}>
        <Typography variant="h6" color="primary">
          {t('invoice:payment_success')}
        </Typography>
      </Box>
    );
  }

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <div id="payment-element" style={{ marginBottom: '20px' }}>
        <PaymentElement
          options={{
            layout: 'accordion'
          }}
        />
      </div>
      {error && (
        <div id="error-message" style={{ color: 'red', marginBottom: '20px' }}>
          {error}
        </div>
      )}
      <Box display="flex" justifyContent="center">
        <Button
          id="submit"
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          disabled={!stripe || processing}
        >
          {processing ? t('invoice:processing') : t('invoice:pay')}
        </Button>
      </Box>
    </form>
  );
};

export default PaymentForm;
